export default __webpack_public_path__ + "static/media/InstagramW.3d6eb9df.svg";